import React, { FC, useCallback, useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'

import { FilterProducts } from 'modulesCommon/Filters/components'
import { productsFiltersVar } from 'modules/Products/store'
import { labelCodeIdVar } from 'modulesCommon/store'
import { GPS_FILTER_OPTIONS, PRODUCTS_FILTER_INIT_VALUES, PRODUCTS_FILTER_STORAGE_NAME } from 'shared/consts/filter'
import { getFromLocalStorageDefValues } from 'shared/utils/getFromLocalStorage'
import { formatFiltersParams } from 'shared/utils/filters'
import { useFormattedZoneList, useLoading, useServerError } from 'shared/hooks'
import { TFilters } from 'shared/types'
import { useZonesList } from 'modulesCommon/serviceHooks'
import { useSpaceZone } from '../serviceHooks/useSpaceZone'

const FilterProductsContainer: FC<{productsTotal: number}> = ({productsTotal}) => {
  const currentLabel = useReactiveVar(labelCodeIdVar)
  const { zoneList, zoneError, zoneLoading } = useZonesList()
  const { unitOptions } = useFormattedZoneList(zoneList, currentLabel)

  const { spaceZoneOptions, spacesError, spacesLoading } = useSpaceZone()

  const handleFilterEntities = useCallback((value: any) => {
    productsFiltersVar(formatFiltersParams(value))
    localStorage.setItem(PRODUCTS_FILTER_STORAGE_NAME, JSON.stringify(value))
  }, [])

  const initialValues = useMemo(
    () => getFromLocalStorageDefValues(PRODUCTS_FILTER_STORAGE_NAME, PRODUCTS_FILTER_INIT_VALUES),
    []
  )

  useServerError([zoneError, spacesError])
  useLoading({ isLoading: zoneLoading || spacesLoading })

  return (
    <FilterProducts
      productsTotal={productsTotal}
      gpsOptions={GPS_FILTER_OPTIONS}
      unitsOptions={unitOptions}
      filterEntities={handleFilterEntities}
      initialValues={initialValues as TFilters}
      defaultValue={PRODUCTS_FILTER_INIT_VALUES as TFilters}
      spacesOptions={spaceZoneOptions}
    />
  )
}

export default FilterProductsContainer
